import {
    ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, Input, Output
} from '@angular/core';
import { Router } from '@angular/router';
import { ErrorService } from '@services/error.service';
import { RemitterService } from '@services/remitter.service';

@Component({
  selector: 'app-upload-kyc',
  templateUrl: './upload-kyc.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadKycComponent {
  @Output() closeModalEvent = new EventEmitter();
  @Output() onSuccess = new EventEmitter<void>();
  @Input() stepToUpload: number = 3;
  @Input() currentStep = 1;
  @Input() allDoneMessage = 'lbl.allDoneSubTitle';
  private readonly errorService = inject(ErrorService);
  readonly unexpectedError$ = this.errorService.unexpectedError$;
  protected isWebview = false;
  steps = [
    {
      id: 1,
      title: 'proofOfAddress',
      subtitle: 'frontOfIdCardSubTitle',
      type: 'proof_of_address'
    },
    {
      id: 2,
      title: 'frontOfIdCard',
      subtitle: 'frontOfIdCardSubTitle',
      type: 'front_id'
    },
    {
      id: 3,
      title: 'backOfIdCard',
      subtitle: 'backOfIdCardSubTitle',
      type: 'back_id'
    }
  ];
  file: any;
  private readonly remitterService = inject(RemitterService);

  @Input() useFinPass: boolean = false;
  protected isDone: boolean = false;
  protected uploadError: boolean = false;
  protected errorMsg: string = '';
  constructor(
    private cdr: ChangeDetectorRef,
    protected router: Router
  ) {}
  ngOnInit() {
    if (this.router.url.includes('/auth/sign-up/new-remitter') && !this.useFinPass || 
      this.router.url.includes('/auth/sign-up/existing')
    ) {
      this.currentStep = 2;
      this.steps = this.steps.filter(step => step.id !== 1);
    }
    if (this.stepToUpload === 1) {
      this.steps = this.steps.filter(step => step.id === 1);
    }
    const userAgent = navigator.userAgent.toLowerCase();
    let safari = /safari/.test(userAgent);
    let ios = /iphone|ipod|ipad/.test(userAgent);
    if (userAgent.indexOf('wv') > -1 || userAgent.indexOf('webview') > -1 || (!safari && ios)) {
      this.isWebview = true;
    }
  }
  closeModal() {
    this.closeModalEvent.emit();
  }
  onUploadedFile(data: File) {
    this.uploadError = false;
    this.errorMsg = '';
    if (data) {
      const formData = new FormData();
      switch (this.currentStep) {
        case 1:
          formData.append('type', 'proof_of_address');
          break;
        case 2:
          formData.append('type', 'front_id');
          break;
        case 3:
          formData.append('type', 'back_id');
          break;
        default:
          break;
      }

      formData.append('document', data);
      this.remitterService.uploadKyc(formData).subscribe(
        (response) => {
          // if (formData.get('type') !== 'proof_of_address') {
          //   this.remitterService.kycCheck().subscribe(
          //     res => {
          //       if (this.currentStep < 3 && this.stepToUpload === 3) {
          //         this.currentStep++;
          //         this.cdr.markForCheck();
          //       } else {
          //         this.isDone = true;
          //         this.cdr.markForCheck();
          //       }
          //     },
          //     error => {
          //       this.showError(error);
          //       this.cdr.markForCheck();
          //     }
          //   );
          // } else {
          //   this.currentStep++;
          //   this.cdr.markForCheck();
          // }
          if (this.currentStep < this.stepToUpload) {
            this.currentStep++;
            this.cdr.markForCheck();
            return;
          }
          this.isDone = true;
          this.cdr.markForCheck();
          if(response.status == 'onfido_kyc_ongoing') {
            this.remitterService.kycCheck().subscribe(() => {});
          }
        },
        error => {
          this.showError(error);
        }
      );
    }
  }

  // backToLogin() {
  //   if (!this.router.url.includes('account/edit-profile?tab=1')) {
  //     // @ts-ignore
  //     if (window?.backToLogin) {
  //       // @ts-ignore
  //       window?.backToLogin?.postMessage('');
  //     }
  //     // @ts-ignore
  //     if (window?.flutter_inappwebview) {
  //       // @ts-ignore
  //       window?.flutter_inappwebview?.callHandler('backToLogin');
  //     }
  //     localStorage.removeItem('access_token');
  //     this.router.navigate(['/auth/login']);
  //   } else {
  //     this.router.navigate(['/account/remitter-profile']);
  //   }
  // }
  handleOnSuccess() {
    this.onSuccess.emit();
  }
  closeModalKyc() {
    // if (this.router.url === '/auth/sign-up/new-remitter') localStorage.removeItem('access_token');
    this.closeModalEvent.emit();
  }

  showError(error: any) {
    if(error.error.errors) {
      this.uploadError = true;
      this.errorMsg = error.error.errors ?? 'Unexpected error occurred.';
      this.cdr.markForCheck();
    }
  }
}
